import { useMemo } from 'react';

import { useErpGroupHomeworkMarksQuery } from 'core/graphql';
import { IHomeworkMarks } from 'components/types';

/**
 * Оценки за домашку по всей группе — для сетки журнала (ТЗ 0026).
 *
 * До сих пор `hw_mark` не был виден в журнале ВООБЩЕ: только в двух вкладках
 * ДЗ на карточке группы и студента. Менеджер не мог одним взглядом понять,
 * кто отстаёт по домашкам, — а ради этого журнал и открывают.
 *
 * Один запрос на группу. Поштучный запрос на занятие здесь недопустим: сетка
 * показывает окно из восьми занятий, но группа живёт сорока.
 */
export const useGroupHomeworkMarks = (groupId: string): IHomeworkMarks => {
  const { data } = useErpGroupHomeworkMarksQuery({
    variables: { groupId },
    skip: !groupId,
  });

  return useMemo(() => {
    const marks: IHomeworkMarks = {};
    (data?.groupHomeworkMarksForErp || []).forEach((cell) => {
      const lessonId = String(cell.lessonId);
      if (!marks[lessonId]) {
        marks[lessonId] = {};
      }
      marks[lessonId][String(cell.studentId)] = {
        hwMark: cell.hwMark ?? null,
        submitted: cell.submitted,
      };
    });
    return marks;
  }, [data?.groupHomeworkMarksForErp]);
};
